// extracted by mini-css-extract-plugin
export default {"advertDetailInfoHeader":"c-j_ff","advertDetailInfoHeader__title":"c-j_fg"};